import React, { Component, useState } from 'react'
import { Link, useHistory } from 'react-router-dom';
import LSHeader from '../../containers/LSHeader';
import Footer from '../../containers/Footer';
import { PostData } from '../../containers/Services/PostData';
import { ApiService } from '../../containers/Services/apiservice';
import { Helmet } from 'react-helmet';
import { Watch } from "react-loader-spinner";
let apiServices = new ApiService();
const Login = () => {
    const [userEmail, setUserEmail] = useState('');
    const [userPassword, setUserPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    let history = useHistory();
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [button, setButton] = useState(true);
    const loginprocess = (e) => {
        e.preventDefault();
        setSpinnerLoading(true);
        if (userEmail == '' || userPassword == '') {
            setErrorMessage("Pleast Enter Email Or Password");
            setLoader(false);
            setButton(true);
            setSpinnerLoading(false);
            return false;
        } else {
            setErrorMessage('');
        }
        const dataString = {
            "user_email": userEmail,
            "user_password": userPassword
        }
        setLoader(true);
        setButton(false);
        apiServices.loginPostRequest(dataString).then(res => {
            if (res.data.status == 'success') {
                localStorage.setItem('AUTH_TOKEN', res.data.auth_token);
                if (res.data.data.gs_status == 0) {
                    setSpinnerLoading(false);
                    history.push("/completeprofile");
                }
                else if (res.data.data.gs_can_register == 0) {
                    setSpinnerLoading(false);
                    history.push("/canregister");
                }
                else if (res.data.data.gs_can_register == 5) {
                    setSpinnerLoading(false);
                    history.push("/canregister/5");
                }
                else if (res.data.data.gs_investor_concent_status == 0) {
                    setSpinnerLoading(false);
                    history.push("/investorconcent");
                }
                else {
                    setSpinnerLoading(false);
                    history.push("/dashboard");
                }
            }
            else {
                setErrorMessage(res.data.message);
                setLoader(false);
                setButton(true);
                setSpinnerLoading(false);
                return false;
            }
        })
            .catch(error => {
            })
    };
    return (
        <div>
            <LSHeader />
            <Helmet>
                <title>Login - Goalstox</title>
                {/* <meta name="keywords" content={pageKeywords}/>  */}
                {/* <meta name="description" content={pageDescription} /> */}
            </Helmet>
            <section>
                <div className={spinnerLoading == true ? 'parentDisable' : ''} width="100%">
                    <div className='overlay-box'>
                        <Watch
                            color="#ffffff"
                            visible={spinnerLoading}
                        />
                    </div>
                </div>
                <div className="container">
                    <div className="login-media align-items-stretch justify-content-center ht-100p">
                        <div className="login-media-img d-none align-items-center d-lg-flex">
                            <div className="mx-wd-600">
                                <img src="/img/login_bg.png" className="img-fluid" alt="" />
                            </div>
                        </div>
                        <div className="sign-wrapper">
                            <div className="wd-100p">
                                <h4>Sign In</h4>
                                <p className="tx-color-03 mg-b-40">Welcome back! Please signin to continue.</p>
                                <form>
                                    <div className="form-group">
                                        <label>Email address</label>
                                        <input type="email"  onChange={(e) => setUserEmail(e.target.value)} className="form-control" placeholder="yourname@yourmail.com" />
                                    </div>
                                    <div className="form-group">
                                        <div className="d-flex justify-content-between mg-b-5">
                                            <label className="mg-b-0-f">Password</label>
                                            <Link to="/resetpassword" className="tx-13">Forgot password?</Link>
                                        </div>
                                        <input type="password" onChange={(e) => setUserPassword(e.target.value)} className="form-control" placeholder="Enter your password" />
                                    </div>
                                    {
                                        errorMessage != '' ? <p className="text text-danger">{errorMessage}</p> : null
                                    }
                                    <button className="btn btn-success button01" onClick={loginprocess}>
                                        {
                                            loader == true ?
                                                <span id="loader"><img style={{ width: '25px' }} src="https://www.codexo.in/goalstox/admin/public/frontend-assets/assets/img/loader.gif" /></span> : null
                                        }
                                        {
                                            button == true ?
                                                <span id="signin">Sign In</span> : null
                                        }
                                    </button>
                                </form>
                                <div className="mg-t-20 tx-center">Don't have an account? <Link to="/register">Create an Account</Link></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}

export default Login;